export const ADD_AREA = "/app/dashboard/area-based-method";
export const ADD_CITY = "/app/dashboard/city-based-method";
export const ADD_COUNTRY = "/app/dashboard/country-based-method";
